// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "prod/js/" + (chunkId === 2850 ? "ReportABugPopup" : chunkId) + "." + {"2850":"46d9b8c0","6732":"a09e210b"}[chunkId] + ".chunk.js";
};